module.exports = __webpack_public_path__ + "img/fashion_34.6c0a8869.jpg";